import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { KSpinner, KSpinnerSize } from "../../KSpinner";
export const GlobalWaiter = ({ globalShowProgress, globalProgress, globalWaiting, waiter }) => {
    let progress;
    if (globalShowProgress) {
        progress = _jsxs("div", { style: { fontSize: 20, color: "#fff" }, children: [Math.floor(globalProgress * 100), "%"] });
    }
    return globalWaiting ? (_jsx("div", { style: { position: "fixed", top: 0, left: 0, bottom: 0, right: 0, backgroundColor: "rgba(0,0,0,0.5)", zIndex: 9000001 }, children: _jsx("div", { className: "kploader-wrapper", children: _jsxs("div", { className: "kpspinner text-center text-light", children: [waiter || _jsx(KSpinner, { size: KSpinnerSize.xxl }), progress] }) }) })) : null;
};
